// teksty: polski zostaje w kodzie jako zapas, angielski przychodzi z window.zpTeksty
function _t(k, d) { var s = window.zpTeksty && window.zpTeksty[k]; return s == null ? d : s; }
/* Zeprado - panel filtrow kolekcji (bez aplikacji Search & Discovery).
 *
 * Co dziala PO STRONIE SERWERA (wyniki i paginacja dokladne):
 *   - tagi:        /collections/<handle>/<tag-handle>+<tag-handle>   (Shopify laczy je AND)
 *   - cena:        ?filter.v.price.gte=<zl>&filter.v.price.lte=<zl>  (wbudowany filtr Shopify)
 *   - dostepnosc:  ?filter.v.availability=1                          (wbudowany filtr Shopify)
 *   - marka:       przelaczenie bazy na kolekcje marka-* z zachowaniem tagow kategorii
 *                  (mozliwe tam, gdzie kolekcje da sie opisac zestawem tagow)
 * Co dziala PO STRONIE PRZEGLADARKI:
 *   - marka w kolekcjach, ktorych nie da sie opisac tagami (np. zbudowanych na typie
 *     produktu) - panel pisze o tym wprost przy filtrze.
 *
 * Liczby przy opcjach licza sie z indeksu assets/zp-filtry-dane.json (zrzut Admin API).
 * Indeks jest porownywany z licznikiem serwera; przy rozbieznosci liczby sa chowane,
 * zeby nie pokazywac nieprawdziwych danych.
 */
(function () {
  'use strict';

  var korzen = document.getElementById('zp-f');
  var konfEl = document.getElementById('zp-f-konf');
  if (!korzen || !konfEl) return;

  var K = JSON.parse(konfEl.textContent);
  var D = null;        // indeks
  var tagIdx = null;   // tag -> indeks
  var baza = null;     // Int32Array: indeksy produktow biezacej kolekcji
  var liczbyPewne = true;

  // grupy z wyborem jednokrotnym (AND po tagach bylby mylacy: "M i L" to nie "M lub L")
  var JEDNOKROTNE = { obwod: 1, 'rozmiar-miseczki': 1, rozmiar: 1, kolor: 1, den: 1, plec: 1 };
  // grupy rysowane jako siatka kafelkow
  var SIATKA = { obwod: 1, 'rozmiar-miseczki': 1, rozmiar: 1, den: 1 };
  // grupy otwarte domyslnie - reszta zwinieta, zeby kolumna nie potrzebowala
  // wlasnego paska przewijania (polecenie wlasciciela z 13.09.2026)
  var OTWARTE = { rozmiar: 1, obwod: 1, 'rozmiar-miseczki': 1, kolor: 1 };
  // dlugie listy w dwoch kolumnach - zamiast scrolla w srodku grupy
  var DWIE = { kolor: 1 };

  var P_CENA_OD = 'filter.v.price.gte';
  var P_CENA_DO = 'filter.v.price.lte';
  var P_DOSTEPNE = 'filter.v.availability';

  var q = new URLSearchParams(location.search);
  var stan = {
    tagi: (K.aktywne || []).slice(),
    marka: q.get('zp_marka') || '',
    cena: null,                                  // [od_zl, do_zl] - jednostki jak w parametrze Shopify
    dostepne: q.get(P_DOSTEPNE) === '1',
    zrodlo: q.get('zp_k') || ''                  // kolekcja, do ktorej wracamy po odznaczeniu marki
  };
  (function () {
    var a = q.get(P_CENA_OD), b = q.get(P_CENA_DO);
    if (a !== null || b !== null) stan.cena = [parseInt(a || '0', 10), b === null ? Infinity : parseInt(b, 10)];
  })();

  var el = {
    chipsy: document.getElementById('zp-f-chipsy'),
    body: korzen.querySelector('[data-zp-body]'),
    wynikow: korzen.querySelector('[data-zp-wynikow]'),
    opis: korzen.querySelector('[data-zp-wynikow-opis]'),
    stan: korzen.querySelector('[data-zp-stan]'),
    wyczysc: korzen.querySelector('[data-zp-wyczysc]'),
    pokaz: korzen.querySelector('[data-zp-pokaz]'),
    otworz: korzen.querySelector('[data-zp-otworz]'),
    zamknij: korzen.querySelector('[data-zp-zamknij]'),
    tlo: korzen.querySelector('[data-zp-tlo]'),
    znacznik: korzen.querySelector('[data-zp-aktywnych]')
  };

  /* ------------------------------- narzedzia ------------------------------- */

  function odmiana(n) {
    if (n === 1) return 'produkt';
    var d = n % 10, s = n % 100;
    return d >= 2 && d <= 4 && !(s >= 12 && s <= 14) ? 'produkty' : _t('f_produktow', 'produktów');
  }

  function zl(kwota) { return kwota + _t('f_zl', ' zł'); }

  function idxKolekcji(h) { return D.kl.indexOf(h); }

  /** Indeksy produktow kolekcji wyjsciowej (bez filtrow uzytkownika).
   *  Gdy marka przelaczyla baze na kolekcje marka-*, liczymy od kolekcji ZRODLOWEJ
   *  (zapamietanej w zp_k) - marka jest wtedy zwyklym filtrem, a nie kategoria. */
  function zbudujBaze() {
    var i, wynik = [];
    var h = stan.zrodlo || K.kolekcja;
    var ki = h && h !== 'all' ? idxKolekcji(h) : -1;
    for (i = 0; i < D.p.length; i++) {
      if (ki < 0 || D.p[i][4].indexOf(ki) !== -1) wynik.push(i);
    }
    return Int32Array.from(wynik);
  }

  /** Czy produkt przechodzi filtry (z pominieciem jednego z nich). */
  function pasuje(pi, tagiIdx, pomin) {
    var p = D.p[pi], i;
    for (i = 0; i < tagiIdx.length; i++) if (p[3].indexOf(tagiIdx[i]) === -1) return false;
    if (pomin !== 'marka' && stan.marka && p[0] !== D.mk.indexOf(stan.marka)) return false;
    if (pomin !== 'cena' && stan.cena) {
      // filtr Shopify dziala na cenach wariantow: produkt pasuje, gdy jego zakres cen nachodzi
      var od = stan.cena[0] * 100, doo = stan.cena[1] === Infinity ? Infinity : stan.cena[1] * 100;
      if (p[1] > doo || p[5] < od) return false;
    }
    if (pomin !== 'dostepnosc' && stan.dostepne && !p[2]) return false;
    return true;
  }

  function aktywneTagiIdx(pominGrupe) {
    var out = [];
    for (var i = 0; i < stan.tagi.length; i++) {
      var ti = tagIdx.get(stan.tagi[i]);
      if (ti === undefined) continue;
      if (pominGrupe != null && D.g[D.gi[ti]].id === pominGrupe) continue;
      out.push(ti);
    }
    return out;
  }

  function ileWszystkich() {
    var t = aktywneTagiIdx(null), n = 0;
    for (var i = 0; i < baza.length; i++) if (pasuje(baza[i], t, null)) n++;
    return n;
  }

  /** Liczby opcji w grupie tagow - bez uwzgledniania wyboru w tej samej grupie. */
  function liczbyGrupy(gid) {
    var t = aktywneTagiIdx(gid), mapa = {};
    for (var i = 0; i < baza.length; i++) {
      var pi = baza[i];
      if (!pasuje(pi, t, null)) continue;
      var tg = D.p[pi][3];
      for (var j = 0; j < tg.length; j++) {
        if (D.g[D.gi[tg[j]]].id === gid) mapa[tg[j]] = (mapa[tg[j]] || 0) + 1;
      }
    }
    return mapa;
  }

  function liczbyMarek() {
    var t = aktywneTagiIdx(null), mapa = {};
    for (var i = 0; i < baza.length; i++) {
      var pi = baza[i];
      if (!pasuje(pi, t, 'marka')) continue;
      var m = D.p[pi][0];
      if (m >= 0) mapa[m] = (mapa[m] || 0) + 1;
    }
    return mapa;
  }

  /** Zakres cen (w zlotych) dostepny przy pozostalych filtrach. */
  function zakresCen() {
    var t = aktywneTagiIdx(null), min = Infinity, max = 0;
    for (var i = 0; i < baza.length; i++) {
      var pi = baza[i];
      if (!pasuje(pi, t, 'cena')) continue;
      if (D.p[pi][1] < min) min = D.p[pi][1];
      if (D.p[pi][5] > max) max = D.p[pi][5];
    }
    return min === Infinity ? [0, 0] : [Math.floor(min / 100), Math.ceil(max / 100)];
  }

  /* --------------------------------- adres --------------------------------- */

  function tagiKolekcji(h) {
    var i = idxKolekcji(h);
    return i >= 0 && D.kt[i] ? D.kt[i] : null;
  }

  /** Czy wybrane tagi same w sobie mieszcza sie w calosci w tej kolekcji?
   *  Jesli tak, kategorie mozna pominac bez zmiany wyniku - i marka moze pojsc serwerem
   *  nawet w kolekcji zbudowanej na typie produktu (np. "majtki"). */
  function tagiImplikujaKolekcje(h) {
    var ki = idxKolekcji(h);
    if (ki < 0) return false;
    var t = aktywneTagiIdx(null);
    if (!t.length) return false;
    for (var i = 0; i < D.p.length; i++) {
      var p = D.p[i], ok = true;
      for (var j = 0; j < t.length; j++) {
        if (p[3].indexOf(t[j]) === -1) { ok = false; break; }
      }
      if (ok && p[4].indexOf(ki) === -1) return false;
    }
    return true;
  }

  /** Czy marke da sie zalatwic serwerem (kolekcja marka-* + tagi kategorii)? */
  function trasaMarki(marka) {
    if (!marka || !D) return null;
    var mi = D.mk.indexOf(marka);
    if (mi < 0 || !D.mh[mi]) return null;
    var zrodlo = stan.zrodlo || K.kolekcja;
    if (!zrodlo || zrodlo === 'all' || zrodlo.indexOf('marka-') === 0) {
      return { kolekcja: D.mh[mi], tagi: [], zrodlo: '' };
    }
    var tk = tagiKolekcji(zrodlo);
    if (tk) return { kolekcja: D.mh[mi], tagi: tk, zrodlo: zrodlo };
    if (tagiImplikujaKolekcje(zrodlo)) return { kolekcja: D.mh[mi], tagi: [], zrodlo: zrodlo };
    return null;
  }

  function adres() {
    var trasa = trasaMarki(stan.marka);
    var kolekcja = K.kolekcja, dodatkowe = [], zrodlo = '';
    if (trasa) {
      kolekcja = trasa.kolekcja;
      dodatkowe = trasa.tagi;
      zrodlo = trasa.zrodlo;
    } else if (stan.zrodlo) {
      kolekcja = stan.zrodlo;               // marka odznaczona - wracamy do kategorii
    }

    var lista = [], widziane = {};
    dodatkowe.concat(stan.tagi).forEach(function (t) {
      var ti = tagIdx.get(t);
      if (ti === undefined || widziane[D.hd[ti]]) return;
      widziane[D.hd[ti]] = 1;
      lista.push(ti);
    });
    lista.sort(function (a, b) { return a - b; });

    var sciezka = '/collections/' + kolekcja +
      (lista.length ? '/' + lista.map(function (ti) { return D.hd[ti]; }).join('+') : '');

    var p = new URLSearchParams(location.search);
    [P_CENA_OD, P_CENA_DO, P_DOSTEPNE, 'zp_marka', 'zp_k', 'page'].forEach(function (n) { p.delete(n); });
    if (stan.cena) {
      p.set(P_CENA_OD, String(stan.cena[0]));
      if (stan.cena[1] !== Infinity) p.set(P_CENA_DO, String(stan.cena[1]));
    }
    if (stan.dostepne) p.set(P_DOSTEPNE, '1');
    if (stan.marka && !trasa) p.set('zp_marka', stan.marka);
    if (zrodlo) p.set('zp_k', zrodlo);
    var qs = p.toString();
    return { sciezka: sciezka, zapytanie: qs, pelny: sciezka + (qs ? '?' + qs : '') };
  }

  /** Czy zmiana wymaga przeladowania (zmienil sie zbior liczony przez serwer)? */
  function trzebaNawigowac(cel) {
    if (cel.sciezka !== location.pathname) return true;
    var teraz = new URLSearchParams(location.search), nowy = new URLSearchParams(cel.zapytanie);
    return [P_CENA_OD, P_CENA_DO, P_DOSTEPNE].some(function (n) {
      return (teraz.get(n) || '') !== (nowy.get(n) || '');
    });
  }

  /* ------------------ filtrowanie kart po stronie przegladarki -------------- */

  var mapaId = null;

  function filtrujKarty() {
    var lista = document.querySelectorAll('.product-grid__item[data-product-id]');
    var klient = !!(stan.marka && !trasaMarki(stan.marka));
    if (!mapaId && D) {
      mapaId = new Map();
      for (var i = 0; i < D.pid.length; i++) mapaId.set(D.pid[i], i);
    }
    var widoczne = 0;
    for (var j = 0; j < lista.length; j++) {
      var li = lista[j], ok = true;
      if (klient && mapaId) {
        var pi = mapaId.get(li.getAttribute('data-product-id'));
        // produkt spoza indeksu zostawiamy widoczny - lepiej pokazac za duzo niz skasowac wynik
        if (pi !== undefined && D.mk[D.p[pi][0]] !== stan.marka) ok = false;
      }
      li.classList.toggle('zp-f-ukryty', !ok);
      if (ok) widoczne++;
    }
    return { widoczne: widoczne, wszystkich: lista.length, klient: klient };
  }

  /* -------------------------------- rysowanie ------------------------------ */

  function element(tag, klasa, tekst) {
    var e = document.createElement(tag);
    if (klasa) e.className = klasa;
    if (tekst != null) e.textContent = tekst;
    return e;
  }

  /* ---------------------- zapisany rozmiar (zp-moj-rozmiar.js) ------------- */

  /** Zbior etykiet do PODSWIETLENIA w danej grupie (nic nie zaznaczamy na sile). */
  function mojeWartosci(gid) {
    var api = window.zpMojRozmiar, p, zbior = {}, k;
    if (!api || typeof api.doFiltrow !== 'function') return null;
    try { p = api.doFiltrow(); } catch (e) { return null; }
    if (!p || !p.jest) return null;
    if (gid === 'obwod' && p.obwod) zbior[String(p.obwod)] = 1;
    if (gid === 'rozmiar-miseczki' && p.miseczka) zbior[String(p.miseczka).toUpperCase()] = 1;
    if (gid === 'rozmiar') {
      if (p.ubranie) zbior[String(p.ubranie).toUpperCase()] = 1;
      if (p.stopa) zbior.__stopa = p.stopa;
    }
    for (k in zbior) return zbior;
    return null;
  }

  /** Czy etykieta opcji to zapisany rozmiar? Zakresy butow (35-37) tez licza sie. */
  function czyMoj(zbior, etykieta) {
    if (!zbior) return false;
    var e = String(etykieta).trim().toUpperCase(), m, a, b, t;
    if (zbior[e] === 1) return true;
    if (zbior.__stopa) {
      m = e.match(/^(\d{2})[-\/](\d{2})$/);
      if (m) {
        a = +m[1]; b = +m[2];
        if (a > b) { t = a; a = b; b = t; }
        return zbior.__stopa >= a && zbior.__stopa <= b;
      }
      if (/^\d{2}$/.test(e)) return +e === zbior.__stopa;
    }
    return false;
  }

  function naglowekGrupy(nazwa, wybrane) {
    var sum = element('summary');
    sum.appendChild(element('span', null, nazwa));
    if (wybrane) sum.appendChild(element('span', 'zp-f__wybrane', wybrane));
    return sum;
  }

  function rysujGrupe(g, opcje, liczby) {
    var jedno = !!JEDNOKROTNE[g.id];
    var wybrane = stan.tagi.filter(function (t) {
      var ti = tagIdx.get(t);
      return ti !== undefined && D.g[D.gi[ti]].id === g.id;
    });
    var moje = mojeWartosci(g.id);
    var det = element('details', 'zp-f__grupa');
    det.open = wybrane.length > 0 || !!OTWARTE[g.id];
    det.dataset.grupa = g.id;
    det.appendChild(naglowekGrupy(g.n, wybrane.map(function (t) { return D.et[tagIdx.get(t)]; }).join(', ')));

    var klasaUl = 'zp-f__opcje';
    if (SIATKA[g.id]) klasaUl += ' zp-f__opcje--siatka';
    else if (DWIE[g.id] && opcje.length > 10) klasaUl += ' zp-f__opcje--dwie';
    var ul = element('ul', klasaUl);
    if (opcje.length > 12 && !SIATKA[g.id]) {
      var szuk = element('input', 'zp-f__szukaj');
      szuk.type = 'search';
      szuk.placeholder = 'Szukaj: ' + g.n.toLowerCase();
      szuk.addEventListener('input', function () {
        var v = szuk.value.trim().toLowerCase();
        ul.querySelectorAll('li').forEach(function (li) {
          li.hidden = v !== '' && li.dataset.et.toLowerCase().indexOf(v) === -1;
        });
      });
      det.appendChild(szuk);
    }

    opcje.forEach(function (ti) {
      var tag = D.tg[ti], n = liczby[ti] || 0, zazn = stan.tagi.indexOf(tag) !== -1;
      var moj = czyMoj(moje, D.et[ti]);
      var li = element('li');
      li.dataset.et = D.et[ti];
      var lab = element('label', 'zp-f__opcja' + (n === 0 && !zazn ? ' zp-f__opcja--pusta' : '') +
        (zazn ? ' zp-f__opcja--zazn' : '') + (moj ? ' zp-f__opcja--moj' : ''));
      if (moj) lab.title = 'To Twój zapisany rozmiar';
      var inp = document.createElement('input');
      inp.type = jedno ? 'radio' : 'checkbox';
      inp.name = 'zp-' + g.id;
      inp.checked = zazn;
      inp.disabled = n === 0 && !zazn;
      inp.addEventListener('change', function () { przelacz(tag, g.id, jedno, inp.checked); });
      if (jedno && zazn) {
        lab.addEventListener('click', function (e) { e.preventDefault(); przelacz(tag, g.id, true, false); });
      }
      lab.appendChild(inp);
      if (D.sw[ti]) {
        var pr = element('span', 'zp-f__probka');
        pr.style.background = D.sw[ti];
        lab.appendChild(pr);
      }
      lab.appendChild(element('span', 'zp-f__opcja-tekst', D.et[ti]));
      if (moj) lab.appendChild(element('span', 'zp-f__moj', _t('f_twoj', 'Twój')));
      if (liczbyPewne) lab.appendChild(element('span', 'zp-f__opcja-ile', String(n)));
      li.appendChild(lab);
      ul.appendChild(li);
    });
    det.appendChild(ul);
    return det;
  }

  function rysujMarki() {
    var liczby = liczbyMarek(), dostepne = [];
    for (var i = 0; i < D.mk.length; i++) if (liczby[i] || D.mk[i] === stan.marka) dostepne.push(i);
    if (dostepne.length < 2) return null;

    var det = element('details', 'zp-f__grupa');
    det.open = true;
    det.appendChild(naglowekGrupy(_t('f_marka', 'Marka'), stan.marka));

    var ul = element('ul', 'zp-f__opcje' + (dostepne.length > 10 ? ' zp-f__opcje--dwie' : ''));
    dostepne.sort(function (a, b) { return (liczby[b] || 0) - (liczby[a] || 0); });
    dostepne.forEach(function (mi) {
      var nazwa = D.mk[mi], zazn = stan.marka === nazwa;
      var li = element('li');
      li.dataset.et = nazwa;
      var lab = element('label', 'zp-f__opcja' + (zazn ? ' zp-f__opcja--zazn' : ''));
      var inp = document.createElement('input');
      inp.type = 'radio';
      inp.name = 'zp-marka';
      inp.checked = zazn;
      inp.addEventListener('change', function () { stan.marka = nazwa; zastosuj(); });
      if (zazn) lab.addEventListener('click', function (e) { e.preventDefault(); stan.marka = ''; zastosuj(); });
      lab.appendChild(inp);
      lab.appendChild(element('span', 'zp-f__opcja-tekst', nazwa));
      if (liczbyPewne) lab.appendChild(element('span', 'zp-f__opcja-ile', String(liczby[mi] || 0)));
      li.appendChild(lab);
      ul.appendChild(li);
    });
    det.appendChild(ul);
    if (stan.marka && !trasaMarki(stan.marka)) {
      det.appendChild(element('p', 'zp-f__uwaga',
        'Tej kategorii nie da się połączyć z marką po stronie serwera - marka filtruje produkty już wczytane na stronie.'));
    }
    return det;
  }

  function rysujCene() {
    var zak = zakresCen(), min = zak[0], max = zak[1];
    if (max <= min) return null;
    var wyb = stan.cena
      ? [Math.max(min, stan.cena[0]), Math.min(max, stan.cena[1] === Infinity ? max : stan.cena[1])]
      : [min, max];

    var det = element('details', 'zp-f__grupa');
    det.open = true;
    det.appendChild(naglowekGrupy(_t('f_cena', 'Cena'), stan.cena ? zl(wyb[0]) + ' - ' + zl(wyb[1]) : ''));

    var box = element('div', 'zp-f__cena');
    var pola = element('div', 'zp-f__cena-pola');
    var od = document.createElement('input'), doo = document.createElement('input');
    [od, doo].forEach(function (x) {
      x.type = 'number';
      x.inputMode = 'numeric';
      x.min = String(min);
      x.max = String(max);
    });
    od.value = String(wyb[0]);
    doo.value = String(wyb[1]);
    od.setAttribute('aria-label', _t('f_cena_od', 'Cena od (zł)'));
    doo.setAttribute('aria-label', _t('f_cena_do', 'Cena do (zł)'));
    pola.appendChild(od);
    pola.appendChild(element('span', null, '-'));
    pola.appendChild(doo);
    box.appendChild(pola);

    var suwak = element('div', 'zp-f__suwak');
    var tor = element('div', 'zp-f__tor'), wyp = element('span');
    tor.appendChild(wyp);
    suwak.appendChild(tor);
    var s1 = document.createElement('input'), s2 = document.createElement('input');
    [s1, s2].forEach(function (s) {
      s.type = 'range';
      s.min = String(min);
      s.max = String(max);
      s.step = '1';
    });
    s1.value = String(wyb[0]);
    s2.value = String(wyb[1]);
    s1.setAttribute('aria-label', _t('f_cena_min', 'Cena minimalna'));
    s2.setAttribute('aria-label', _t('f_cena_max', 'Cena maksymalna'));
    suwak.appendChild(s1);
    suwak.appendChild(s2);
    box.appendChild(suwak);

    function malujTor() {
      var a = Math.min(+s1.value, +s2.value), b = Math.max(+s1.value, +s2.value);
      wyp.style.left = ((a - min) / (max - min) * 100) + '%';
      wyp.style.width = ((b - a) / (max - min) * 100) + '%';
    }
    malujTor();

    function ustaw(a, b) {
      a = Math.max(min, Math.min(a, max));
      b = Math.max(min, Math.min(b, max));
      if (a > b) { var t = a; a = b; b = t; }
      stan.cena = (a <= min && b >= max) ? null : [a, b];
      zastosuj();
    }

    [s1, s2].forEach(function (s) {
      s.addEventListener('input', function () {
        var a = Math.min(+s1.value, +s2.value), b = Math.max(+s1.value, +s2.value);
        od.value = String(a);
        doo.value = String(b);
        malujTor();
      });
      s.addEventListener('change', function () {
        ustaw(Math.min(+s1.value, +s2.value), Math.max(+s1.value, +s2.value));
      });
    });
    [od, doo].forEach(function (x) {
      x.addEventListener('change', function () {
        ustaw(parseInt(od.value || String(min), 10), parseInt(doo.value || String(max), 10));
      });
    });

    box.appendChild(element('p', 'zp-f__uwaga', 'Zakres cen w tej kategorii: ' + zl(min) + ' - ' + zl(max) + '.'));
    det.appendChild(box);
    return det;
  }

  function rysujDostepnosc() {
    var det = element('details', 'zp-f__grupa');
    det.open = !!stan.dostepne;
    det.appendChild(naglowekGrupy(_t('f_dostepnosc', 'Dostępność'), stan.dostepne ? _t('f_tylko_dostepne_m', 'tylko dostępne') : ''));
    var ul = element('ul', 'zp-f__opcje');
    var li = element('li');
    li.dataset.et = 'dostepne';
    var lab = element('label', 'zp-f__opcja' + (stan.dostepne ? ' zp-f__opcja--zazn' : ''));
    var inp = document.createElement('input');
    inp.type = 'checkbox';
    inp.checked = stan.dostepne;
    inp.addEventListener('change', function () { stan.dostepne = inp.checked; zastosuj(); });
    lab.appendChild(inp);
    lab.appendChild(element('span', 'zp-f__opcja-tekst', _t('f_tylko_dostepne', 'Tylko dostępne')));
    li.appendChild(lab);
    ul.appendChild(li);
    det.appendChild(ul);
    return det;
  }

  function rysujPanel() {
    var frag = document.createDocumentFragment();
    D.g.forEach(function (g) {
      var opcje = [];
      for (var i = 0; i < D.tg.length; i++) if (D.g[D.gi[i]].id === g.id) opcje.push(i);
      if (!opcje.length) return;
      var liczby = liczbyGrupy(g.id);
      var widoczne = opcje.filter(function (ti) { return liczby[ti] || stan.tagi.indexOf(D.tg[ti]) !== -1; });
      if (widoczne.length < 2) return;
      frag.appendChild(rysujGrupe(g, widoczne, liczby));
    });
    var m = rysujMarki();
    if (m) frag.appendChild(m);
    var c = rysujCene();
    if (c) frag.appendChild(c);
    frag.appendChild(rysujDostepnosc());
    el.body.replaceChildren(frag);
  }

  function rysujChipsy() {
    var frag = document.createDocumentFragment(), ile = 0;

    function chip(tekst, usun, klasa) {
      var b = element('button', 'zp-f__chip' + (klasa ? ' ' + klasa : ''));
      b.type = 'button';
      b.appendChild(element('span', null, tekst));
      if (usun) {
        b.insertAdjacentHTML('beforeend',
          '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" fill="none"/></svg>');
        b.setAttribute('aria-label', _t('f_usun', 'Usuń filtr: ') + tekst);
        b.addEventListener('click', usun);
      }
      frag.appendChild(b);
    }

    stan.tagi.forEach(function (t) {
      var ti = tagIdx.get(t);
      if (ti === undefined) return;
      ile++;
      chip(D.g[D.gi[ti]].n + ': ' + D.et[ti], function () {
        stan.tagi = stan.tagi.filter(function (x) { return x !== t; });
        zastosuj();
      });
    });
    if (stan.marka) { ile++; chip('Marka: ' + stan.marka, function () { stan.marka = ''; zastosuj(); }); }
    if (stan.cena) {
      ile++;
      chip('Cena: ' + zl(stan.cena[0]) + ' - ' + (stan.cena[1] === Infinity ? 'bez górnej' : zl(stan.cena[1])),
        function () { stan.cena = null; zastosuj(); });
    }
    if (stan.dostepne) { ile++; chip(_t('f_tylko_dostepne', 'Tylko dostępne'), function () { stan.dostepne = false; zastosuj(); }); }
    if (ile > 1) chip(_t('f_wyczysc', 'Wyczyść wszystko'), wyczysc, 'zp-f__chip--czysc');

    el.chipsy.replaceChildren(frag);
    el.chipsy.hidden = ile === 0;
    el.wyczysc.hidden = ile === 0;
    if (el.znacznik) {
      el.znacznik.hidden = ile === 0;
      el.znacznik.textContent = String(ile);
    }
  }

  var komunikat = null;
  function pustaSiatka(pokaz) {
    var siatka = document.querySelector('.product-grid');
    if (!siatka) return;
    if (pokaz && !komunikat) {
      komunikat = element('li', 'zp-f-pusto',
        _t('f_brak_marki', 'Żaden z wczytanych produktów nie jest tej marki. Przewiń niżej, żeby wczytać kolejne, albo wybierz inny filtr.'));
      siatka.appendChild(komunikat);
    } else if (!pokaz && komunikat) {
      komunikat.remove();
      komunikat = null;
    }
  }

  function rysujLicznik() {
    var n = D ? ileWszystkich() : K.wynikow;
    var ks = filtrujKarty();
    el.wynikow.textContent = String(n);
    el.opis.textContent = odmiana(n);
    var info = el.stan.querySelector('.zp-f__uwaga');
    if (ks.klient && ks.wszystkich) {
      if (!info) {
        info = element('span', 'zp-f__uwaga');
        info.style.display = 'block';
        el.stan.appendChild(info);
      }
      info.textContent = 'Na tej stronie widocznych ' + ks.widoczne + ' z ' + ks.wszystkich +
        _t('f_marka_info', ' - marka filtruje produkty już wczytane.');
      pustaSiatka(ks.widoczne === 0 && ks.wszystkich > 0);
    } else {
      if (info) info.remove();
      pustaSiatka(false);
    }
    if (el.pokaz) {
      el.pokaz.replaceChildren(document.createTextNode(_t('f_pokaz', 'Pokaż ')), element('span', null, n + ' ' + odmiana(n)));
    }
  }

  /* --------------------------------- akcje --------------------------------- */

  function przelacz(tag, gid, jedno, wlaczony) {
    if (jedno) {
      stan.tagi = stan.tagi.filter(function (t) {
        var ti = tagIdx.get(t);
        return ti === undefined || D.g[D.gi[ti]].id !== gid;
      });
      if (wlaczony) stan.tagi.push(tag);
    } else if (wlaczony) {
      if (stan.tagi.indexOf(tag) === -1) stan.tagi.push(tag);
    } else {
      stan.tagi = stan.tagi.filter(function (x) { return x !== tag; });
    }
    zastosuj();
  }

  function wyczysc() {
    stan.tagi = [];
    stan.marka = '';
    stan.cena = null;
    stan.dostepne = false;
    location.href = '/collections/' + (stan.zrodlo || K.kolekcja || 'all');
  }

  var odroczone = false;   // telefon: zmiany czekaja na przycisk _t('f_pokaz_wyniki', "Pokaz wyniki")

  function zastosuj() {
    var cel = adres();
    if (!odroczone) {
      if (trzebaNawigowac(cel)) {
        location.href = cel.pelny;
        return;
      }
      history.replaceState(null, '', cel.pelny);
    }
    rysujPanel();
    rysujChipsy();
    rysujLicznik();
  }

  function otworzPanel() {
    odroczone = true;
    korzen.setAttribute('data-otwarty', '');
    el.tlo.hidden = false;
    el.otworz.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function zamknijPanel(zastosowac) {
    korzen.removeAttribute('data-otwarty');
    el.tlo.hidden = true;
    el.otworz.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    odroczone = false;
    if (zastosowac) zastosuj();
  }

  /* ------------------------- kontekst kolekcji (plec) ---------------------- */

  /** Plec kolekcji z tagow produktow; handle sluzy tylko jako zapasowa wskazowka. */
  function zHandla(h) {
    h = String(h || '');
    if (/mesk|dla-niego|bokserki|slipy|kalesony|podkoszul/.test(h)) return 'm';
    if (/damsk|dla-niej|biustonosz|rajstop|ponczoch|majtki|figi|stringi|halka|braletk|body/.test(h)) return 'd';
    return 'x';
  }

  function kontekstKolekcji() {
    var iM = tagIdx.get('plec:meskie'), iD = tagIdx.get('plec:damskie');
    var m = 0, d = 0, i, tagi;
    for (i = 0; i < baza.length; i++) {
      tagi = D.p[baza[i]][3];
      if (iM !== undefined && tagi.indexOf(iM) > -1) m++;
      if (iD !== undefined && tagi.indexOf(iD) > -1) d++;
    }
    var suma = m + d, plec = 'x';
    if (suma >= 3) {
      if (m >= suma * 0.7) plec = 'm';
      else if (d >= suma * 0.7) plec = 'd';
    }
    if (plec === 'x') plec = zHandla(stan.zrodlo || K.kolekcja);
    return { plec: plec, meskich: m, damskich: d, razem: baza.length };
  }

  var probyKontekstu = 0;

  function podajKontekst() {
    var api = window.zpMojRozmiar;
    if (api && typeof api.ustawKontekst === 'function') {
      var k = kontekstKolekcji();
      api.ustawKontekst(k);
      korzen.setAttribute('data-zp-plec', k.plec);
      return;
    }
    if (probyKontekstu++ < 10) setTimeout(podajKontekst, 200);
  }

  /* ---------------------------------- start -------------------------------- */

  el.otworz.addEventListener('click', otworzPanel);
  el.zamknij.addEventListener('click', function () { zamknijPanel(true); });
  el.tlo.addEventListener('click', function () { zamknijPanel(true); });
  el.pokaz.addEventListener('click', function () { zamknijPanel(true); });
  el.wyczysc.addEventListener('click', wyczysc);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && korzen.hasAttribute('data-otwarty')) zamknijPanel(true);
  });
  /* zapisany rozmiar sie zmienil - przerysowujemy podswietlenia (bez nawigacji) */
  document.addEventListener('zp:rozmiar-zmiana', function () { if (D) rysujPanel(); });
  document.addEventListener('zp:rozmiar', function () { if (D) rysujPanel(); });

  fetch(K.dane, { credentials: 'omit' })
    .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status)); })
    .then(function (dane) {
      D = dane;
      tagIdx = new Map();
      for (var i = 0; i < D.tg.length; i++) tagIdx.set(D.tg[i], i);
      baza = zbudujBaze();

      // tagi, ktore tylko odtwarzaja kolekcje zrodlowa, nie sa wyborem uzytkownika
      if (stan.zrodlo) {
        var tk = tagiKolekcji(stan.zrodlo) || [];
        stan.tagi = stan.tagi.filter(function (t) { return tk.indexOf(t) === -1; });
      }
      // wejscie prosto na /collections/marka-* traktujemy jak wybor marki
      if (!stan.marka && K.kolekcja.indexOf('marka-') === 0) {
        var mi = D.mh.indexOf(K.kolekcja);
        if (mi >= 0) stan.marka = D.mk[mi];
      }

      // kontrola indeksu licznikiem serwera (bez filtra marki liczonego w przegladarce)
      var zapamietana = stan.marka;
      if (stan.marka && !trasaMarki(stan.marka)) stan.marka = '';
      var zIndeksu = ileWszystkich();
      stan.marka = zapamietana;
      liczbyPewne = Math.abs(zIndeksu - K.wynikow) <= Math.max(2, K.wynikow * 0.02);
      if (!liczbyPewne && window.console) {
        console.warn('[zp-filtry] indeks (' + zIndeksu + ') != serwer (' + K.wynikow + ') - liczby ukryte');
      }

      podajKontekst();
      rysujPanel();
      rysujChipsy();
      rysujLicznik();

      var siatka = document.querySelector('.product-grid');
      if (siatka && window.MutationObserver) {
        new MutationObserver(function () { rysujLicznik(); }).observe(siatka, { childList: true });
      }
    })
    .catch(function (e) {
      el.body.replaceChildren(element('p', 'zp-f__uwaga', _t('f_blad', 'Nie udało się wczytać listy filtrów. Odśwież stronę.')));
      if (window.console) console.warn('[zp-filtry]', e);
    });
})();
